import styled from 'styled-components';
import Chevron from 'js/components/core/Icons/Chevron';

export default styled(Chevron)`
  align-self: center;
  height: 0.8rem;
`;
